import React, { useMemo } from "react";

export default function EntertainmentDynamicFilterSliders({
    sliderData,
    checkedFilters = {},
    isLoading,
    onLoadMore,
}) {
    /**
     * STEP 1: Normalize array
     */
    const dataArray = useMemo(() => {
        if (sliderData?._embedded?.events) {
            return sliderData._embedded.events;
        }
        if (Array.isArray(sliderData)) {
            return sliderData;
        }
        return [];
    }, [sliderData]);

    /**
     * STEP 2: Map data
     */
    const mappedData = useMemo(() => {
        return dataArray.map((item) => {
            if (item?.images) {
                const image =
                    item.images.find((img) => img.ratio === "16_9")?.url ||
                    item.images[0]?.url ||
                    "";

                return {
                    id: item.id,
                    name: item.name,
                    image_url: image,
                    url: item.url,
                    rating:
                        item.classifications?.[0]?.genre?.name ||
                        item.classifications?.[0]?.segment?.name ||
                        "Music",
                };
            }

            return {
                id: item.id || item._id,
                name: item.name || "Untitled",
                image_url: item.image_url || "",
                url: item.url || "#",
                rating: item.rating || "Music",
            };
        });
    }, [dataArray]);

    return (
        <>
            {/* Header */}
            <div className="delivery_restaurant_header mt-3">
                <h2 className="mb-0">
                    {Object.keys(checkedFilters).length > 0
                        ? Object.keys(checkedFilters).join(", ")
                        : "Music Events"}
                </h2>
            </div>

            {/* Cards */}
            <div className="row gy-4 pt-4">
                {mappedData.length > 0 ? (
                    mappedData.map((ele) => (
                        <div className="col-lg-6 col-md-6 col-xl-4" key={ele.id}>
                            <div className="card-item h-100">
                                <div className="resorts-box p-3 bg-white h-100">
                                    <figure>
                                        <img
                                            src={ele.image_url}
                                            alt={ele.name}
                                            loading="lazy"
                                            className="img-fluid"
                                        />
                                    </figure>

                                    <div className="resorts-content-box">
                                        <div className="resort-description border-0 m-0 pb-0">
                                            <span className="rating-star">
                                                <i className="fa-solid fa-music"></i> {ele.rating}
                                            </span>

                                            <h3 className="mb-3 mt-2">
                                                {ele.name.length > 22
                                                    ? `${ele.name.slice(0, 22)}...`
                                                    : ele.name}
                                            </h3>

                                            <div className="book-trip-btn">
                                                <a
                                                    href={ele.url}
                                                    target="_blank"
                                                    rel="noreferrer"
                                                    className="w-100 text-center d-block"
                                                >
                                                    Book Tickets
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))
                ) : (
                    <div className="col-12 text-center">
                        <p>No music events found</p>
                    </div>
                )}
            </div>

            {
                mappedData.length > 0 && (
                    <div className="d-flex justify-content-center mt-5">
                        <button
                            className="view-all-btn"
                            disabled={isLoading}
                            onClick={onLoadMore}
                        >
                            {isLoading ? "Loading..." : "Load More"}
                        </button>
                    </div>
                )
            }

        </>
    );
}
